import { observable } from "mobx";

class ProfileLinksStore {
	constructor(rootStore, staticContext) {
		this.rootStore = rootStore;
		this._city = staticContext.city;
		this.service = staticContext.service || staticContext.midtail;
		this._popular = staticContext.popularServices;
		this._nearby = staticContext.nearByCities;
		this._related = staticContext.relatedServices;
	}

	_city = "";
	get city() {
		return this._city;
	}

	set city(city) {
		this._city = city;
	}

	_popular = [];
	get popular() {
		return this._popular;
	}

	set popular(popular) {
		this._popular = popular;
	}

	_nearby = [];
	get nearby() {
		return this._nearby;
	}

	_related = [];
	get related() {
		return this._related;
	}

	set nearby(nearby) {
		this._nearby = nearby;
	}
}

export default ProfileLinksStore;
